import { render, staticRenderFns } from "./DailyArticle.vue?vue&type=template&id=ea9acfe2&"
import script from "./DailyArticle.vue?vue&type=script&lang=js&"
export * from "./DailyArticle.vue?vue&type=script&lang=js&"
import style0 from "./DailyArticle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports